import { toast } from "sonner";
import type Deal from "@/model/interface/Deal";
import { useUpdateDealStageMutation } from "@/store/rest_api";
import { apiErrorMessage } from "@/util/apiError";
import { getContactDisplayName } from "@/util/string";
import { useConversionToast } from "@/hooks/useConversionToast";

export function useMoveDealStage() {
  const [updateDealStage, { isLoading }] = useUpdateDealStageMutation();
  const showConversionToast = useConversionToast();

  const moveDealStage = async (deal: Pick<Deal, "id" | "contact">, stageId: string): Promise<Deal | undefined> => {
    try {
      const moved = await updateDealStage({ id: deal.id, stageId }).unwrap();
      showConversionToast(moved.convertedContactId, getContactDisplayName(moved.contact ?? deal.contact));
      return moved;
    } catch (error) {
      toast.error(apiErrorMessage(error, "Failed to move the deal"));
      return undefined;
    }
  };

  return { moveDealStage, isMoving: isLoading };
}
